import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useHasPermission } from '@/entities/profile';
import { useReportKnowledgeNode } from '../model';
import { ReportReferenceDialog } from './ReportReferenceDialog';

type Props = {
  nodeId?: number;
  onClose: () => void;
};

export const KnowledgeNodeDetailDialog: FC<Props> = ({ nodeId, onClose }) => {
  const { t } = useTranslation(['dialogs']);
  const { name, text, isLoading, path, permission } = useReportKnowledgeNode(nodeId);
  const canOpenSection = useHasPermission(permission);
  return (
    <ReportReferenceDialog
      isOpen={!!nodeId}
      title={`${t('expertReport.knowledgeNodeTitle')}: ${name}`}
      text={text}
      isLoading={isLoading}
      // Переход ведёт в раздел, которому знание принадлежит, — без права на него само знание всё равно читается
      linkPath={canOpenSection ? path : undefined}
      onClose={onClose}
    />
  );
};
